import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { AvatarLarge } from '../../components';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, currentUser } = props;
  const images = listing.images;
  /* P25009-448 BR-3 — a package whose hero was rendered (tyre composed onto
   * rim) says so under the gallery. The rim-photo fallback is a real photo
   * and gets no line. */
  const isIllustrated = listing?.attributes?.publicData?.renderedImage?.kind === 'combination';
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  /* P25009-482 BR-10 — thumbnails use the SCALED variants, never the card
   * crop: the listing-card variants are fit=crop, which cut the wheel
   * off at the edges of a square. A scaled image shows all of it (fit=clip in
   * imgix terms); the thumbnail box letterboxes it (object-fit: contain). */
  const thumbnailVariants = ['scaled-small', 'scaled-medium'];
  const bio = listing?.author?.attributes?.profile?.bio || "";
  const isBusinessUser = listing?.author?.attributes?.profile?.publicData.userType === 'business';

  const extraSlide = isBusinessUser ? (
    <div className={css.avatarBioSlide}>
      <AvatarLarge user={listing.author} className={css.businessAvatar} />
      {bio && <p className={css.businessBio}>{bio}</p>}
    </div>
  ) : null;

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        extraSlide={extraSlide}
        currentUser={currentUser}
        currentListing={listing}
      />
      {isIllustrated ? (
        <p className={css.illustrationNotice}>
          <FormattedMessage id="ListingPage.illustrationNotice" />
        </p>
      ) : null}
    </section>
  );
};

export default SectionGallery;
